import React from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import makeStyles from "@mui/styles/makeStyles";
import styles from "./styles";

import { Box, CircularProgress } from "@mui/material/";

const AuditAsset = () => {
    const classes = makeStyles(styles)();
    const { auditAssets } = useSelector((state) => state);

    return (
        <>
            {!auditAssets.data.item ? (
                <Outlet />
            ) : (
                <Box className={classes.box}>
                    <CircularProgress />
                </Box>
            )}
        </>
    );
};

export default AuditAsset;
